import util from '@bmp-vue/core/api/util'
import Axios from 'axios'

const controller = 'Partner'
const getToken = () => JSON.parse(localStorage.getItem('user'))?.token;
const url = process.env.VUE_APP_ROOT_API + controller

export default Object.assign({}, util.GetCrud(controller, ['none']), {
  GetReferenceToken: function (token) {
    const headers = { Authorization: `Bearer ${getToken()}` }
    return Axios.post(url + '/GetReferenceToken/' + token, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleErrorBase)
  },
})
